import { ShoppingCart, Star, Eye } from "lucide-react";
import { useState, useEffect } from "react";

interface ProductStatsPreviewProps {
  settings: {
    purchasesCount?: number;
    reviewsCount?: number;
    viewingCount?: number;
    minViewingCount?: number;
    maxViewingCount?: number;
    viewingUpdateInterval?: number;
    showPurchases?: boolean;
    showReviews?: boolean;
    showViewing?: boolean;
    backgroundColor?: string;
    textColor?: string;
    iconColor?: string;
    borderRadius?: string;
    padding?: string;
  };
}

export const ProductStatsPreview = ({ settings }: ProductStatsPreviewProps) => {
  const [currentViewers, setCurrentViewers] = useState(settings.viewingCount || 15);

  useEffect(() => {
    if (!settings.showViewing) return;

    const min = settings.minViewingCount || 15;
    const max = settings.maxViewingCount || 25;
    const interval = (settings.viewingUpdateInterval || 3) * 1000;

    const timer = setInterval(() => {
      const randomCount = Math.floor(Math.random() * (max - min + 1)) + min;
      setCurrentViewers(randomCount);
    }, interval);

    return () => clearInterval(timer);
  }, [settings.showViewing, settings.minViewingCount, settings.maxViewingCount, settings.viewingUpdateInterval]);

  return (
    <div
      className="flex flex-wrap items-center justify-center gap-4 sm:gap-6"
      style={{
        backgroundColor: settings.backgroundColor || "transparent",
        color: settings.textColor || "#000000",
        borderRadius: `${settings.borderRadius || 8}px`,
        padding: `${settings.padding || 16}px`,
      }}
    >
      {settings.showPurchases && (
        <div className="flex items-center gap-2">
          <ShoppingCart
            className="h-4 w-4 sm:h-5 sm:w-5"
            style={{ color: settings.iconColor || "#10b981" }}
          />
          <span className="font-semibold text-sm sm:text-base">{settings.purchasesCount || 0} عملية شراء</span>
        </div>
      )}
      
      {settings.showReviews && (
        <div className="flex items-center gap-2">
          <Star
            className="h-4 w-4 sm:h-5 sm:w-5 fill-current"
            style={{ color: settings.iconColor || "#fbbf24" }}
          />
          <span className="font-semibold text-sm sm:text-base">{settings.reviewsCount || 0} تقييم</span>
        </div>
      )}
      
      {settings.showViewing && (
        <div className="flex items-center gap-2">
          <Eye
            className="h-4 w-4 sm:h-5 sm:w-5"
            style={{ color: settings.iconColor || "#3b82f6" }}
          />
          <span className="font-semibold text-sm sm:text-base">{currentViewers} يشاهدون الآن</span>
        </div>
      )}
    </div>
  );
};
